<div class="form-field" [formGroup]='parent'
  [ngClass]="{'has-error': parent.get([controlName]) && parent.get([controlName]).touched && parent.get([controlName]).errors}">
  <label [id]="controllerData['name']" [attr.for]="pageName+'-'+controllerData['name']" class="form-label">{{pageName === 'yourPensionSavings' ? '' : controllerData['label']}}</label>

  <input [formControlName]="controlName" [name]="controllerData['name']"
    [type]="controllerData['type']"
    [id]="getId()"
    [(ngModel)]="textValue"
    [attr.aria-invalid]="(parent.get([controlName]).touched && parent.get([controlName]).errors 
    && controllerData['errorMessage'] && controllerData['errorMessage'] !== '') ? true : false" 
    [placeholder]="controllerData['placeHolder']"
    [maxlength]="controllerData['maxlength']"
    class="form-control "
    [value]="(pageName === 'yourPensionSavings' ? textValue : textValue | uppercase)"
    (blur)="inputTextChangeHandler($event.target.value)"
    [required]="controllerData['required']"
    (keypress)="addhyphen($event.target.value, $event)"
    [readonly]="controllerData['readonly']"
    autocomplete="off"
    [ngClass]="{'upperCase':toUpperCase}"
    [attr.inputmode]="(isNumeric && isNumeric === true ? 'numeric' : 'text')"
    />
  </div>

  @if (parent.get([controlName]).touched && parent.get([controlName]).errors
    && controllerData['errorMessage']
    && controllerData['errorMessage'] !== '') {
    <div [id]="controlName+'-error'" class="form-validation-error error-wid"
      [ngClass]="{'width-100':(pageName === 'yourPensionSavings')}">
      <i class="icon icon-error" aria-hidden="true"></i>
      <!-- <p [id]="controlName+'-error-msg'" role="alert"
    aria-live="polite" aria-hidden="false">{{controllerData['errorMessage']}}</p> -->
    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).hasError('required')) {
      <p
      [id]="controlName +'-error'">{{controllerData['errorMessage']}}</p>
    }
    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).errors.pattern) {
      <p [id]="controlName +'-invalid-error'">
        {{controllerData['errorMessageInvalid']}}
      </p>
    }
    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).hasError('matchInvalid')) {
      <p [id]="controlName +'-invalid-error'">
        {{controllerData['errorMatch']}}
      </p>
    }
    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).hasError('notValidPlanNumber')) {
      <p [id]="controlName +'-invalidPlanNumber-error'">
        {{controllerData['invalidErrorMessage']}}
      </p>
    }
    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).hasError('notValidname')) {
      <p [id]="controlName +'-invalid-error'">
        {{controllerData['errorMessageInvalid']}}
      </p>
    }
  </div>
}